import './Header.css';
import BlackLogo from '../../assets/img/Newsily logo-black.png';
import User from '../../assets/image/user.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import LogOutBtn from '../Buttons/LogOutBtn/LogOutBtn';



const Header = () => {
    return ( 
        <div className="header">
            <div className="container">
                <div className="row d-flex justify-content-center align-items-center">
                    <div className="d-none d-md-flex d-lg-flex col-md-3 col-lg-3 logo">
                        <img src={ BlackLogo } alt="blacklogo" />
                    </div>
                    <div className="col-lg-5 d-none col-md-4 d-md-flex d-lg-flex">

                    </div>
                    <div className="col-sm-6 col-6 col-lg-2 col-md-3 d-flex justify-content-between">
                        <h6><img src={ User } alt="user icon" />Username</h6>
                    </div>
                    <div className="col-sm-6 col-6 col-lg-2 col-md-2">
                        <LogOutBtn />
                    </div>
                    
                </div>
            </div>
        </div>
     );
}
 
export default Header;